import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { ToastMessageService } from '../services/toast-message.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const _Router = inject(Router);
  const _toasterService = inject(ToastMessageService);
  const storageService = inject(StorageService) as StorageService; // Assert the type of storageService

  // Logic to verify token here
  if (storageService.getToken()) {
    return true;
  } else {
    _Router.navigate(['/login']);
    return false;
  }
};
